import React from 'react';
import { Divider } from '@mui/material';
import { isProTeam } from '../../../../utils';
import { useUser } from '../../../../hooks/useUser';
import FormRow from './row';
import FieldInput from './FieldInput';

export default function FormSocialReach() {
  const { role } = useUser();

  return (
    <>
      <FormRow count={2}>
        <FieldInput name="facebook" label="Facebook" />
        <FieldInput
          name="facebookFollowers"
          label="Facebook Followers"
          type="number"
        />
      </FormRow>

      <FormRow count={2}>
        <FieldInput name="twitter" label="Twitter" />
        <FieldInput
          name="twitterFollowers"
          label="Twitter Followers"
          type="number"
        />
      </FormRow>

      <FormRow count={2}>
        <FieldInput name="instagram" label="Instagram" />
        <FieldInput
          name="instagramFollowers"
          label="Instagram Followers"
          type="number"
        />
      </FormRow>

      <FormRow count={2}>
        <FieldInput name="tiktok" label="Tiktok" />
        <FieldInput
          name="tiktokFollowers"
          label="Tiktok Followers"
          type="number"
        />
      </FormRow>

      <FormRow count={2}>
        <FieldInput name="youtube" label="YouTube" />
        <FieldInput
          name="youtubeSubscribers"
          label="YouTube Subscribers"
          type="number"
        />
      </FormRow>

      <FormRow count={2}>
        <FieldInput name="pinterest" label="Pinterest" />
        <FieldInput
          name="pinterestFollowers"
          label="Pinterest Followers"
          type="number"
        />
      </FormRow>

      <FormRow count={2}>
        <FieldInput name="linkedin" label="LinkedIn" />
      </FormRow>

      {isProTeam(role) && (
        <>
          <Divider />

          <FormRow count={2}>
            <FieldInput
              name="totalReach"
              label="Total Reach"
              type="number"
              readOnly
            />
          </FormRow>
        </>
      )}
    </>
  );
}
